import React from 'react';
import TruckMonthLogo from '../../../assets/icons/Ford_TruckMonth_Logo.svg';
import {tagConnectWithADealerClick} from '../../../Services/TaggingService/TaggingService';
import {updateToggleDealerConnectDialog} from '../../../redux/app-state-slice';

function SpecialEventApprovedSection({customerData, dispatch}) {
  const showDealerConnectDialog = () => {
    tagConnectWithADealerClick(customerData.specialEvent.value);
    dispatch(updateToggleDealerConnectDialog(true));
  };

  return (
    <div className='prequal--wc--offer-nextstep-container' data-testid='truck-month-icon-container'>
      <div>
        <img className='truck-month-icon' src={TruckMonthLogo} alt='truck-month-logo' />
      </div>

      <span className='prequal--wc--dealermsg-text'>Send this prequalification to your local dealer to continue to your next Ford.</span>
      <div className='prequal--wc--offer-sendtodealer-container'>
        <div className='prequal--wc--offer-sendtodealer-button'>
          <button
            className='prequal--wc--offer-sendtodealer-text'
            type='button'
            data-testid='connect-with-dealer-button'
            onClick={() => {
              showDealerConnectDialog();
            }}
          >
            Send To Dealer
          </button>
        </div>
      </div>
    </div>
  );
}

export default SpecialEventApprovedSection;
